import type { PropsWithChildren, ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useMedia } from '@/hooks';
import { CopyCode } from '../../../../components/CopyCode';
import { Logo } from '../../../../components/Logo';
import type { LogoSize } from '../../../../components/Logo/styled';
import { ScHeroV2 } from './styled';

export const HeroV2 = ({
  children,
  code,
  image,
  spins,
  text,
  translation,
  isImagesHidden,
  logo,
  logoSize,
  button,
  copyCodeTitle,
}: PropsWithChildren<{
  code?: string;
  image: { desk: string; mob: string };
  spins?: number;
  text?: string;
  translation: string;
  isImagesHidden?: boolean;
  logo?: string;
  logoSize?: LogoSize;
  button: ReactElement;
  copyCodeTitle?: string;
}>) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(translation);
  const { isMobile } = useMedia();

  return (
    <ScHeroV2 isImagesHidden={isImagesHidden}>
      <Logo logoSize={logoSize} logoSrc={logo} />
      <picture>{children}</picture>
      <div className="hero__container">
        <picture>{children}</picture>
        <div className="hero__content">
          {t('noDeposit') !== 'noDeposit' && (
            <div className="hero__text1">{t('noDeposit')}</div>
          )}

          {t('bigOfferTop') !== 'bigOfferTop' && (
            <div className="big-offer">
              <div className="big-offer__top">
                <span>{t('bigOfferTop.left')}</span>
                <span className="right">
                  <Trans
                    components={{
                      br: <br />,
                    }}
                    i18nKey={`${translation}:bigOfferTop.right`}
                  />
                </span>
              </div>
              <div className="big-offer__bottom">
                <span>{t('bigOfferBottom.left')}</span>
                <span className="right">
                  <Trans
                    components={{
                      br: <br />,
                    }}
                    i18nKey={`${translation}:bigOfferBottom.right`}
                  />
                </span>
              </div>
            </div>
          )}

          <div className="hero__offer">
            {spins && (
              <div className={`hero__text2 ${language}`}>
                <span className="hero__text2-1">{spins}</span>
                <span className="hero__text2-2">{t('common:freeSpins')}</span>
              </div>
            )}

            {text && (
              <div className="hero__text3">
                <span>{t('onSlot', { text })}</span>
              </div>
            )}
          </div>
          {code && (
            <CopyCode
              code={code}
              copyCodeTitle={copyCodeTitle}
              noMarginBottom
            />
          )}
          {isMobile && button}
        </div>

        <div className="hero__imgContainer">
          <img alt="Character" className="image-desk" src={image.desk} />
          <img alt="Character" className="image-mob" src={image.mob} />
        </div>
      </div>
    </ScHeroV2>
  );
};
